import React, { useMemo } from 'react';
import { YotpoStarDistributionObject } from '../../Types/Yotpo';

const YotpoStarDistribution = ({
  totalReviews,
  starDistribution,
}: {
  totalReviews: number;
  starDistribution?: YotpoStarDistributionObject;
}) => {
  const getStarPercent = (value: number) =>
    totalReviews > 0 ? (value / totalReviews) * 100 : 0;

  const sortedKeys = useMemo(
    () =>
      Object.keys(starDistribution ?? {}).sort((a, b) => (b > a ? 1 : -1)),
    [starDistribution]
  );

  return starDistribution && totalReviews > 0 ? (
    <div className="mx-auto w-full max-w-sm">
      {sortedKeys.map((key) => (
        <div
          key={'star-distribution-' + key}
          className="mb-2 grid grid-cols-6 items-center justify-items-center gap-2"
        >
          <span className="justify-self-end text-md">{key}</span>
          <div className="col-span-4 h-2 w-full rounded bg-gray-200">
            <div
              className="h-full rounded bg-gray-700"
              style={{
                width: `${getStarPercent(starDistribution[key])}%`,
              }}
            >
              &nbsp;
            </div>
          </div>
          <span className="justify-self-start text-md">
            {Math.floor(getStarPercent(starDistribution[key])).toString()}%
          </span>
        </div>
      ))}
    </div>
  ) : null;
};

export default YotpoStarDistribution;
